import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideIn24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowSlideIn24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M15.212 19.57a7.54 7.54 0 0 1-4.382-1.4l1.224-1.34a5.77 5.77 0 1 0-.494-9.295l-1.34-1.223a7.54 7.54 0 0 1 4.992-1.881l.389.01a7.57 7.57 0 0 1-.389 15.13m-6.318-4.356A.9.9 0 0 1 7.62 13.94l1.025-1.024h-6.43a.9.9 0 0 1 0-1.8h6.44L7.62 10.08a.901.901 0 0 1 1.274-1.273l3.203 3.203-.58.579a1 1 0 0 1-.121.122z"
            />
        </svg>
    );
}
export default memo(IconArrowSlideIn24);
